import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import Modal from '../Modal';
import Form from '../Form';
import Button from '../Button';
import Icon from '../Icon';
import Emailer from '../Emailer';

import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.overview.send-to-admissions.title',
    defaultMessage: 'Send a message to the admissions office',
  },
  submit: {
    id: 'hubs.overview.send-to-admissions.submit',
    defaultMessage: 'Submit',
  },
});

class SendToAdmissions extends React.PureComponent {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    userEmail: PropTypes.string,
    admissionsOffice: PropTypes.object,
    sendEmail: PropTypes.func,
    intl: PropTypes.object,
  };

  state = {
    subject: '',
    body: '',
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleSubjectChange = value => {
    this.setState({
      subject: value,
    });
  };

  handleBodyChange = value => {
    this.setState({
      body: value,
    });
  };

  handleSubmit = () => {
    const { sendEmail } = this.props;
    const { subject, body } = this.state;

    const payload = {
      type: 'admissions',
      subject,
      text: body,
    };

    const callback = () => this.handleClose();

    sendEmail(payload)
      .then(callback)
      .catch(callback);
  };

  render() {
    const { open, userEmail, admissionsOffice } = this.props;

    return (
      <Modal
        as={Form}
        open={open}
        onClose={this.handleClose}
        className="send-to-admissions"
        data-cy="send-to-admissions"
        onSubmit={this.handleSubmit}
        size="small"
      >
        <Modal.Header>
          <button
            type="button"
            onClick={this.handleClose}
            className="close-modal"
            aria-label="Close"
          >
            <Icon size="small" name="close" />
          </button>
          <h1 className="title">
            <FormattedMessage {...messages.title} />
          </h1>
        </Modal.Header>
        <Modal.Content>
          <Emailer
            userEmail={userEmail}
            admissionsOffice={admissionsOffice}
            onSubjectChange={this.handleSubjectChange}
            onBodyChange={this.handleBodyChange}
            showAddress
          />
        </Modal.Content>
        <Modal.Actions>
          <Button primary type="submit" onClick={this.handleButton}>
            <FormattedMessage {...messages.submit} />
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default injectIntl(SendToAdmissions);
